import "./BackButton.css";
import Button from "react-bootstrap/Button";

function BackButton(props) {
    return (
        <Button className="back-button" variant="light" onClick={props.onClick}>Zurück</Button>
    )
}

export default BackButton;